import { createRouter, createWebHistory } from 'vue-router';
import Cookies from 'js-cookie';
import DescopeSignup from './components/descope/DescopeSignup.vue';
import DescopeLogin from './components/descope/DescopeLogin.vue';
import DescopeLogout from './components/descope/DescopeLogout.vue';
import DescopeMobileLogin from './components/descope/DescopeMobileLogin.vue';
import DescopeTestLogin from './components/descope/DescopeTestLogin.vue';
import DescopeTestSignup from './components/descope/DescopeTestSignup.vue';
import DescopeMobileTestLogin from './components/descope/DescopeMobileTestLogin.vue';
import ErrorBoundary from './components/Common/ErrorBoundary.vue';
import config from './config';
import DDLogs from './DDLogs';
import DescopeMemberInvite from './components/descope/DescopeMemberInvite.vue';
import ReferToDownloadApp from './components/Common/ReferToDownloadApp.vue';
import GoToApp from './components/Common/GoToApp.vue';
import WelcomeNewMember from './components/member-join/WelcomeNewMember.vue';
import JoinRiseup from './components/member-join/JoinRiseup.vue';

const COOKIE_EXPIRATION_DAYS = 7;

const routes = [
  {
    path: '/',
    name: 'UnAuthenticatedRoutes',
    component: ErrorBoundary,
    beforeEnter: gretaBeforeEnter,
    children: [
      {
        path: 'login/mobile',
        component: DescopeMobileLogin,
      },
      {
        path: 'login',
        component: DescopeLogin,
      },
      {
        path: 'logout',
        component: DescopeLogout,
      },
      {
        path: 'signup',
        component: DescopeSignup,
      },
      {
        path: 'invite',
        component: DescopeMemberInvite,
      },
      {
        path: 'welcome-join',
        component: WelcomeNewMember,
      },
      {
        path: 'join-riseup',
        component: JoinRiseup,
      },
      {
        path: 'start-trial',
        component: ReferToDownloadApp,
        props: { title: 'Your 7 day free trial starts now.', text: 'Want to find out your monthly forecast? Download the app now.' },
      },
      {
        path: 'test/login',
        component: DescopeTestLogin,
      },
      {
        path: 'test/signup',
        component: DescopeTestSignup,
      },
      {
        path: 'test/mobile',
        component: DescopeMobileTestLogin,
      },
      {
        path: 'redirect',
        component: GoToApp,
        props: { title: 'Success!', text: 'You’ve successfully logged in, and can now continue to the app.' },
      },
    ],
  },
];

function gretaBeforeEnter() {
  const gclid = new URLSearchParams(window.location.search).get('gclid');
  if (gclid) {
    DDLogs.info('User came with gclid', { gclid });
    const { hostname } = new URL(config.get().gretaPublicUrl);
    const domain = `.${hostname.split('.').slice(1).join('.')}`;
    Cookies.set('gclid', gclid, { expires: COOKIE_EXPIRATION_DAYS, domain, path: '/' });
  }
}

const router = createRouter({
  history: createWebHistory(),
  routes,
});
export default router;
